import { gql } from '@apollo/client';

export const GET_TICKET_ALLOCATION = gql`
query GET_TICKET_ALLOCATION($officerId: ID!, $originatorId: ID!){
  getTicketAllocation(officerId: $officerId, originatorId: $originatorId) {
    id
    employee {
      id
    }
    startingTicketNumber
    endingTicketNumber
  }
}`;


